import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "green"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_5 = { class: "mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = { class: "text-xs text-gray-500" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "text-xs text-gray-400" }
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = { class: "text-xs text-gray-500" }
const _hoisted_17 = { class: "text-xs text-gray-400" }
const _hoisted_18 = { class: "text-xs text-gray-400 ml-auto" }
const _hoisted_19 = { class: "mb-8 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden map-container" }
const _hoisted_20 = {
  ref: "mapContainer",
  style: {"height":"320px","width":"100%"}
}
const _hoisted_21 = {
  key: 1,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_22 = { class: "grid gap-4" }
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "flex items-start justify-between" }
const _hoisted_25 = { class: "flex-1" }
const _hoisted_26 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_27 = { class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800" }
const _hoisted_28 = { class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800" }
const _hoisted_29 = { class: "grid grid-cols-2 sm:grid-cols-3 gap-4 mb-3" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "text-xs text-gray-500" }
const _hoisted_32 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "text-xs text-gray-500" }
const _hoisted_35 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_36 = { class: "text-xs text-gray-500" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "text-sm font-semibold text-gray-900"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "text-xs text-gray-500 mb-1" }
const _hoisted_42 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_43 = { class: "inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-xs font-medium text-blue-800 shrink-0" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 1,
  class: "text-xs text-gray-400"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = {
  key: 0,
  class: "flex flex-col gap-2 ml-4"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6" }
const _hoisted_56 = { class: "text-lg font-bold text-gray-900 mb-6" }
const _hoisted_57 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_58 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_59 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_60 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_61 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_62 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_63 = {
  ref: "formMapContainer",
  style: {"height":"200px","width":"100%"},
  class: "rounded-lg border border-gray-300"
}
const _hoisted_64 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_65 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_66 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_67 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6" }
const _hoisted_70 = { class: "text-lg font-bold text-gray-900 mb-2" }
const _hoisted_71 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_72 = { class: "flex justify-end gap-3" }
const _hoisted_73 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "shared_runs"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createCommentVNode(" Shared Runs "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('shared_runs.title')), 1 /* TEXT */),
        ($props.signedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: $setup.openCreateModal,
              class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
            }, _toDisplayString($setup.t('shared_runs.create')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Filters "),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createCommentVNode(" Date range "),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString($setup.t('shared_runs.filter_date')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.filterDateFrom) = $event)),
              type: "date",
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterDateFrom]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "—", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.filterDateTo) = $event)),
              type: "date",
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterDateTo]
            ])
          ]),
          _createCommentVNode(" My runs filter "),
          ($props.signedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = $event => ($setup.filterMy = 'all')),
                  class: _normalizeClass(['px-3 py-1.5 text-xs font-medium rounded-lg transition', $setup.filterMy === 'all' ? 'bg-blue-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'])
                }, _toDisplayString($setup.t('shared_runs.filter_all_runs')), 3 /* TEXT, CLASS */),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = $event => ($setup.filterMy = 'mine')),
                  class: _normalizeClass(['px-3 py-1.5 text-xs font-medium rounded-lg transition', $setup.filterMy === 'mine' ? 'bg-blue-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'])
                }, _toDisplayString($setup.t('shared_runs.filter_my_runs')), 3 /* TEXT, CLASS */),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = $event => ($setup.filterMy = 'joined')),
                  class: _normalizeClass(['px-3 py-1.5 text-xs font-medium rounded-lg transition', $setup.filterMy === 'joined' ? 'bg-blue-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'])
                }, _toDisplayString($setup.t('shared_runs.filter_joined')), 3 /* TEXT, CLASS */)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Distance range "),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString($setup.t('shared_runs.filter_distance')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.filterDistanceMin) = $event)),
              type: "number",
              min: "0",
              step: "1",
              placeholder: $setup.t('shared_runs.filter_from'),
              class: "w-16 text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 8 /* PROPS */, _hoisted_12), [
              [
                _vModelText,
                $setup.filterDistanceMin,
                void 0,
                { number: true }
              ]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "—", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.filterDistanceMax) = $event)),
              type: "number",
              min: "0",
              step: "1",
              placeholder: $setup.t('shared_runs.filter_to'),
              class: "w-16 text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 8 /* PROPS */, _hoisted_13), [
              [
                _vModelText,
                $setup.filterDistanceMax,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("span", _hoisted_14, _toDisplayString($setup.t('shared_runs.km')), 1 /* TEXT */)
          ]),
          _createCommentVNode(" Pace range "),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString($setup.t('shared_runs.filter_pace')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.filterPaceMin) = $event)),
              type: "text",
              placeholder: "3:00",
              pattern: "\\d{1,2}:\\d{2}",
              class: "w-16 text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterPaceMin]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "—", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.filterPaceMax) = $event)),
              type: "text",
              placeholder: "7:00",
              pattern: "\\d{1,2}:\\d{2}",
              class: "w-16 text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterPaceMax]
            ]),
            _createElementVNode("span", _hoisted_17, _toDisplayString($setup.t('shared_runs.min_km')), 1 /* TEXT */)
          ]),
          _createElementVNode("span", _hoisted_18, _toDisplayString($setup.filteredRuns.length) + " / " + _toDisplayString($setup.runs.length), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Map "),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.runsWithCoords.length > 0]
      ]),
      _createCommentVNode(" Flash message "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Runs list "),
      ($setup.filteredRuns.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.t('shared_runs.no_runs')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredRuns, (run) => {
          return (_openBlock(), _createElementBlock("div", {
            key: run.id,
            id: `run-${run.id}`,
            class: _normalizeClass(['rounded-xl shadow-sm border p-6 transition', $setup.isPast(run) ? 'bg-gray-50 border-gray-200 opacity-60' : 'bg-white border-gray-200 hover:shadow-md'])
          }, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString($setup.formatDate(run.date)), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_28, _toDisplayString($setup.formatTime(run.date)), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (run.distance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("p", _hoisted_31, _toDisplayString($setup.t('shared_runs.distance')), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_32, _toDisplayString(run.distance) + " " + _toDisplayString($setup.t('shared_runs.km')), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (run.pace)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("p", _hoisted_34, _toDisplayString($setup.t('shared_runs.pace')), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_35, _toDisplayString(run.pace) + " " + _toDisplayString($setup.t('shared_runs.min_km')), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_36, _toDisplayString($setup.t('shared_runs.organizer')), 1 /* TEXT */),
                    ($props.signedIn && run.organizer.id !== $props.userId)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          onClick: $event => ($setup.openChatWith(run.organizer)),
                          class: "text-sm font-semibold text-gray-900 hover:text-blue-700 cursor-pointer"
                        }, _toDisplayString(run.organizer.name || run.organizer.email), 9 /* TEXT, PROPS */, _hoisted_37))
                      : (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(run.organizer.name || run.organizer.email), 1 /* TEXT */)),
                    _createCommentVNode(" Organizer: toggle phone visibility "),
                    (run.organizer.id === $props.userId && run.organizer_has_phone)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: $event => ($setup.togglePhone(run)),
                          class: _normalizeClass(['mt-1 text-xs font-medium cursor-pointer', run.phone_visible ? 'text-blue-700' : 'text-gray-400'])
                        }, _toDisplayString(run.phone_visible ? $setup.t('shared_runs.phone_shown') : $setup.t('shared_runs.phone_hidden')), 11 /* TEXT, CLASS, PROPS */, _hoisted_39))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Participant: see phone if visible "),
                    (run.organizer.id !== $props.userId && run.organizer.phone && $setup.isParticipant(run))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          href: 'tel:' + run.organizer.phone,
                          class: "mt-1 inline-flex items-center gap-1 text-xs text-blue-700 hover:text-blue-900"
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("svg", {
                            class: "w-3 h-3",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            })
                          ], -1 /* CACHED */)),
                          _createTextVNode(" " + _toDisplayString(run.organizer.phone), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_40))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_41, _toDisplayString($setup.t('shared_runs.participants')) + " (" + _toDisplayString(run.participants.length) + "):", 1 /* TEXT */),
                  (run.participants.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(run.participants, (p) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: p.id,
                            class: "flex items-center gap-2 text-sm text-gray-700"
                          }, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString((p.first_name || p.name).charAt(0).toUpperCase()), 1 /* TEXT */),
                            ($props.signedIn && p.id !== $props.userId)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  onClick: $event => ($setup.openChatWith({ id: p.id, name: p.name })),
                                  class: "hover:text-blue-700 cursor-pointer"
                                }, _toDisplayString(p.name), 9 /* TEXT, PROPS */, _hoisted_44))
                              : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(p.name), 1 /* TEXT */)),
                            _createCommentVNode(" Participant toggles own phone visibility "),
                            (p.id === $props.userId && p.has_phone)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  onClick: $event => ($setup.toggleParticipantPhone(run)),
                                  class: _normalizeClass(['text-xs cursor-pointer', p.phone_visible ? 'text-blue-700' : 'text-gray-400'])
                                }, _toDisplayString(p.phone_visible ? $setup.t('shared_runs.phone_shown') : $setup.t('shared_runs.phone_hidden')), 11 /* TEXT, CLASS, PROPS */, _hoisted_46))
                              : _createCommentVNode("v-if", true),
                            _createCommentVNode(" Organizer sees phone if participant consented "),
                            (p.phone && run.organizer.id === $props.userId)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  href: 'tel:' + p.phone,
                                  class: "inline-flex items-center gap-1 text-xs text-blue-700 hover:text-blue-900"
                                }, [
                                  _cache[18] || (_cache[18] = _createElementVNode("svg", {
                                    class: "w-3 h-3",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                    })
                                  ], -1 /* CACHED */)),
                                  _createTextVNode(" " + _toDisplayString(p.phone), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_47))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString($setup.t('shared_runs.no_participants')), 1 /* TEXT */))
                ]),
                _createElementVNode("a", {
                  href: '/shared_runs/' + run.id,
                  class: "mt-3 inline-block text-sm text-blue-700 font-medium hover:text-blue-900 hover:underline"
                }, _toDisplayString($setup.t('shared_runs.details')) + " → ", 9 /* TEXT, PROPS */, _hoisted_49)
              ]),
              ($props.signedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (!$setup.isPast(run) && !$setup.isParticipant(run) && run.organizer.id !== $props.userId)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: $event => ($setup.joinRun(run)),
                          class: "px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
                        }, _toDisplayString($setup.t('shared_runs.join')), 9 /* TEXT, PROPS */, _hoisted_51))
                      : _createCommentVNode("v-if", true),
                    (!$setup.isPast(run) && $setup.isParticipant(run))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: $event => ($setup.leaveRun(run)),
                          class: "px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                        }, _toDisplayString($setup.t('shared_runs.leave')), 9 /* TEXT, PROPS */, _hoisted_52))
                      : _createCommentVNode("v-if", true),
                    (run.organizer.id === $props.userId || $props.userAdmin)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("button", {
                            onClick: $event => ($setup.openEditModal(run)),
                            class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                          }, _toDisplayString($setup.t('shared_runs.edit')), 9 /* TEXT, PROPS */, _hoisted_53),
                          _createElementVNode("button", {
                            onClick: $event => ($setup.confirmDelete(run)),
                            class: "px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
                          }, _toDisplayString($setup.t('shared_runs.delete')), 9 /* TEXT, PROPS */, _hoisted_54)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_23))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createCommentVNode(" Create/Edit Modal "),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("h2", _hoisted_56, _toDisplayString($setup.editing ? $setup.t('shared_runs.edit_run') : $setup.t('shared_runs.new_run')), 1 /* TEXT */),
            ($setup.formErrors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formErrors, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "text-sm text-red-700"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.submitForm, ["prevent"]),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_58, _toDisplayString($setup.t('shared_runs.date')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.date) = $event)),
                  type: "datetime-local",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.date]
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString($setup.t('shared_runs.distance')) + " (" + _toDisplayString($setup.t('shared_runs.km')) + ")", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.form.distance) = $event)),
                    type: "number",
                    step: "0.01",
                    min: "0",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.distance]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString($setup.t('shared_runs.pace')) + " (" + _toDisplayString($setup.t('shared_runs.min_km')) + ")", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.form.pace) = $event)),
                    type: "text",
                    placeholder: "5:30",
                    pattern: "\\d{1,2}:\\d{2}",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.pace]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_62, _toDisplayString($setup.t('shared_runs.pick_location')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_63, null, 512 /* NEED_PATCH */)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString($setup.t('shared_runs.latitude')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.form.latitude) = $event)),
                    type: "number",
                    step: "0.0000001",
                    readonly: "",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.latitude]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString($setup.t('shared_runs.longitude')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.form.longitude) = $event)),
                    type: "number",
                    step: "0.0000001",
                    readonly: "",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.longitude]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: $setup.closeModal,
                  class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                }, _toDisplayString($setup.t('shared_runs.cancel')), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.submitting,
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.submitting ? '...' : ($setup.editing ? $setup.t('shared_runs.save') : $setup.t('shared_runs.create'))), 9 /* TEXT, PROPS */, _hoisted_68)
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Delete Confirmation Modal "),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeDeleteModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h2", _hoisted_70, _toDisplayString($setup.t('shared_runs.confirm_delete')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_71, _toDisplayString($setup.t('shared_runs.confirm_delete_message')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                onClick: $setup.closeDeleteModal,
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('shared_runs.cancel')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.deleteRun,
                disabled: $setup.submitting,
                class: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
              }, _toDisplayString($setup.submitting ? '...' : $setup.t('shared_runs.delete')), 9 /* TEXT, PROPS */, _hoisted_73)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}